export enum QuickActionPanelType {
  PARAPHRASE = 'PARAPHRASE',
  EXPAND = 'EXPAND',
  SHORTEN = 'SHORTEN',
}
